/**
 * The version of the application
 *
 * @type {string}
 */
export const APP_VERSION = process.env.VUE_APP_VERSION

/**
 * How often do we try to fetch the onboarding for QR code based ones.
 * As we are doing things asynchronously we need to wait for an onboarding to be created in our DB
 * specifically if we are using QR Codes.
 *
 * Every try has a 1 second delay
 *
 * @type {number}
 */
export const MAX_FETCH_TRIES = 20

/**
 * Name of the token cookie
 *
 * @type {string}
 */
export const TOKEN_COOKIE_NAME = 'hello_token'
